var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Stepper',_vm._g(_vm._b({ref:"stepper",attrs:{"steps":_vm.steps,"current-step":_vm.currentStepNum}},'Stepper',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }